import { Box } from "@mui/material";

import { Option } from "api/common/types/common.types";
import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const PcmPPSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    ppOptions: [] as Option[],
  },
  render: function Render({ form, ppOptions }) {
    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField name="protectionProfiles">
          {(field) => (
            <field.MultiAutocompleteSelect
              options={ppOptions}
              label="Protection Profile Claims"
              required
            />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default PcmPPSection;
